module.exports = __webpack_public_path__ + "img/tobacco.42d2b02c.svg";